import React from 'react';
import { map, difference } from 'lodash';
import useSheet from 'app/jss';

type Props = {
  classes: object,
  children?: any,
  currentItemId?: number | string,
  itemIds?: Array<number | string>,
  itemsPerPage?: number,
};

type State = {
  pages: number,
  currentPage: number,
};

function getItemPage(itemId: number | string, itemList: Array<number | string>, itemsPerPage: number) {
  const page = (itemList.indexOf(itemId) + 1) / itemsPerPage;
  return Math.max(Math.ceil(page), 1);
}

// Higher level component that'll provide the current page information
// to child components
class PaginationManager extends React.Component {
  props: Props;

  constructor(props: Props) {
    super(props);
    this.state = {
      pages: Math.ceil(props.itemIds.length / props.itemsPerPage),
      currentPage: getItemPage(props.currentItemId, props.itemIds, props.itemsPerPage),
    };
  }

  static defaultProps = {
    itemIds: [],
    itemsPerPage: 5,
    currentItemId: undefined,
    children: undefined,
  };

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const oldIds = map(this.props.itemIds, 'id');
    const newIds = map(nextProps.itemIds, 'id');
    const groupDiffs = difference(oldIds, newIds).concat(difference(newIds, oldIds));
    // if we've changed
    if (groupDiffs.length > 0 || this.props.currentItemId !== nextProps.currentItemId) {
      const totalPages = Math.ceil(nextProps.itemIds.length / nextProps.itemsPerPage);
      this.setState({
        pages: Math.max(totalPages, 1),
        currentPage: getItemPage(nextProps.currentItemId, map(nextProps.itemIds, 'id'), nextProps.itemsPerPage),
      });
    }
  }

  setPage = (page: number) => {
    this.setState({ currentPage: page });
  }

  render() {
    const {
      classes,
      children,
    } = this.props;

    const child = React.Children.only(children);
    const cloneProps = {
      ...child.props,
      currentPage: this.state.currentPage,
      pages: this.state.pages,
      onPageChange: this.setPage,
    };

    return React.cloneElement(child, cloneProps);
  }
}

function applyStyles(theme: Theme) {
  return {

  };
}

export default useSheet(applyStyles)(PaginationManager);
